export default function ConsultaCatalogo() {
    return (
        <div className="container mt-5">
            <h1>Consulta de catalogo</h1>
        </div>
    )
}
